import { useContext } from "react"
import ToastContext from './ToastContext';

export const useToast = () => {
    const { toast, setToast } = useContext(ToastContext);

    const display = message => {
        if (!message || !message.severity || !message.titre || !message.text) {
            return;
        }
        setToast([...toast, message]);
    }

    return {display}
}